import axios from "axios";

export const checkPolicyAcceptance = async ({
  policyType,
  policyVersion,
  clientId,
}: {
  policyType: string;
  policyVersion: string;
  clientId?: string;
}) => {
  try {
    const res = await axios.post("/policy/check", {
      policyType,
      policyVersion,
      clientId,
    });
    return res.data;
  } catch (err: any) {
    return {
      success: false,
      accepted: false,
      error: err?.response?.data?.message || err?.message || "Error checking policy",
    };
  }
};

export const acceptPolicy = async ({
  policyType,
  policyVersion,
  clientId,
}: {
  policyType: string;
  policyVersion: string;
  clientId?: string;
}) => {
  try {
    const res = await axios.post("/policy/accept", {
      policyType,
      policyVersion,
      clientId,
    });
    return res.data;
  } catch (err: any) {
    return {
      success: false,
      error: err?.response?.data?.message || err?.message || "Error accepting policy",
    };
  }
};

export const getPolicyDownloadUrl = async (downloadPath: string) => {
  try {
    const res = await axios.post("/policy/download", { key: downloadPath });
    return res.data;
  } catch (err: any) {
    return {
      success: false,
      error: err?.response?.data?.message || err?.message || "Error getting download URL",
    };
  }
};

export const getPolicyHistory = async () => {
  try {
    const res = await axios.get("/policy/history");
    return res.data;
  } catch (err: any) {
    return {
      success: false,
      data: [],
      error: err?.response?.data?.message || err?.message || "Error fetching policy history",
    };
  }
};
